import { createContext, FunctionComponent, ReactNode } from 'react';

// While Business Settings is mounted, shared hooks such as useMarketplace read
// marketplace.settingsMarketplace instead of the logged-in marketplace.
export const BusinessSettingsMarketplaceContext = createContext(false);

export const BusinessSettingsMarketplaceProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => (
    <BusinessSettingsMarketplaceContext.Provider value={true}>{children}</BusinessSettingsMarketplaceContext.Provider>
);
